import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { ChevronLeft, ChevronRight } from '@yme/assets/icons';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { getIsDriverLicenseEnabled, getRTL } from '@yme/selectors/common';
import { getNavProducts } from '../redux/selectors';
import { MegamenuListItemStyled } from '../styled';
import { createSubMenu } from './helpers';
export function MenuItemWithSubMenu({ item, closeMenuHandler, driverLicenseLabel, label, isTwoLevelsView, }) {
    const [isHovered, setIsHovered] = useState(false);
    const { title, childPages, pageType, inRiverId, isImageFullWidth, link, hasExtraMenuTitle } = item;
    const isRightToLeft = useSelector(getRTL);
    const navProducts = useSelector(getNavProducts);
    const isDriverLicenseEnabled = useSelector(getIsDriverLicenseEnabled);
    const currentChevronIcon = isRightToLeft ? ChevronLeft : ChevronRight;
    const mouseEnterHandler = useCallback(() => {
        setIsHovered(true);
    }, []);
    return (React.createElement(MegamenuListItemStyled, { key: title, isRightToLeft: isRightToLeft, onMouseEnter: mouseEnterHandler },
        React.createElement("span", null, title),
        React.createElement(SVGIcon, { type: currentChevronIcon, size: ICON_SIZE.xs }),
        isHovered &&
            createSubMenu(childPages, isRightToLeft, pageType, closeMenuHandler, driverLicenseLabel, navProducts, isDriverLicenseEnabled, isImageFullWidth, link, title, label, inRiverId, false, hasExtraMenuTitle, isTwoLevelsView)));
}
